<template>
  <div>
    <div
      v-for="(item, index) in paragraphs"
      :key="item.title"
      :id="item.paragraphId"
    >
      <div class="paragraph-container">
        <div class="title">{{ item.title }}</div>
        <Materials
          :paragraph-index="index"
          :materials="item.materials"
        ></Materials>
        <Upload class="add-bar" clean @on-success="(file) => handleSuccess(index, file)">
          <i class="el-icon-circle-plus-outline"></i>
          <span class="ml5">添加图片/视频</span>
        </Upload>
      </div>
    </div>
  </div>
</template>

<script>
import Materials from "@/components/Materials";
import Upload from "@/components/Upload";
export default {
  components: { Materials, Upload },
  inject: ['editControl'],
  props: {
    paragraphs: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleSuccess(index, file) {
      this.editControl.handleAddMaterial(index, file)
    }
  }
};
</script>

<style lang="scss" scoped>
.ml5 {
  margin-left: 5px;
}
.paragraph-container {
  border-radius: 8px;
  border: 1px solid #ebebeb;
  padding: 16px 20px;
  margin-bottom: 15px;
}
.title {
  text-align: center;
  font-size: 14px;
  color: #333;
  margin-bottom: 15px;
}
.add-bar {
  height: 34px;
  border: 1px dashed #ebebeb;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #999;
  cursor: pointer;
}
</style>